<template>
  <Modal
    ref="modal"
    title="Grußkarten Motivauswahl"
    class="modal-postcard-motives"
  >
    <template v-slot:content>
      <ul
        v-if="$store.getters.getUserGroupId === 62"
        class="modal-postcard-motives__categories"
      >
        <li class="modal-postcard-motives__category">
          <Tag
            @click="selectedCategoryId = -1"
            :isSelected="selectedCategoryId === -1"
          >
            Alle
          </Tag>
        </li>
        <li
          v-for="(item, index) in categories"
          :key="index"
          class="modal-postcard-motives__category"
        >
          <Tag
            @click="selectedCategoryId = item.id"
            :isSelected="selectedCategoryId === item.id"
          >
            {{ item.name }}
          </Tag>
        </li>
      </ul>

      <ul class="modal-postcard-motives__list">
        <li
          v-for="(motive, index) in postcards"
          :key="index"
          class="modal-postcard-motives__item"
        >
          <div
            @click="select(motive)"
            class="modal-postcard-motives__card"
            :class="{ '--is-selected' : selectedCard.id === motive.id }"
          >
            <div class="modal-postcard-motives__picture">
              <img :src="motive.main_image_medium[0]" :alt="'Grußkarte ' + motive.name">

              <i class="icon icon-check-circle modal-postcard-motives__check"></i>
            </div>

            <span class="modal-postcard-motives__name">
              {{ motive.name.substring(0, 16) }}<slot v-if="motive.name.length > 16">…</slot>
            </span>
          </div>
        </li>
      </ul>
    </template>

    <template v-slot:footer>
      <Button
        @click="submit()"
        appearance="primary"
        :disabled="!selectedCard.id"
      >
        Auswahl bestätigen
      </Button>

      <Button
        @click="$refs.modal.close()"
        appearance="secondary"
      >
        Abbrechen
      </Button>
    </template>
  </Modal>
</template>

<script>
import { UiMixin } from '@/mixins/UiMixin';

import Modal from '@/components/Composer/Modal';
import Tag from '@/components/Common/Tag';
import Button from '@/components/Common/Button';

export default {
  name: 'ModalPostcardMotives',
  mixins: [UiMixin],
  props: {
    selectionData: {
      type: Object
    },
    isLoaded: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Modal,
    Tag,
    Button
  },
  data () {
    return {
      selectedCategoryId: -1,
      selectedCard: {}
    };
  },
  methods: {
    select (motive) {
      this.selectedCard = motive;
    },

    submit () {
      if (this.selectionData.card.id) {
        this.selectionData.mode = 1;
      }

      if (this.selectedCard.main_image_medium) {
        this.selectionData.mode = 1;
        this.selectionData.card.id = this.selectedCard.id;
        this.selectionData.card.src = this.selectedCard.main_image_medium[0];

        this.$store.commit('setSelectedPostcardId', this.selectedCard.id);
        this.$store.commit('setSelectedPostcardImage', this.selectedCard.main_image_medium[0]);
        this.$store.commit('setSelectedPostcardName', this.selectedCard.name);
      }

      this.$refs.modal.close({
        submit: true
      });

      setTimeout(() => {
        this.scrollToComposerSection('_ModulePostcardMessage');
      }, 600);
    }
  },
  computed: {
    postcards () {
      if (this.$store.getters.getPostcards) {
        return Object.values(this.$store.getters.getPostcards).filter(postcard => {
          var matches = 0;

          postcard.categories.filter((category) => {
            if (this.selectedCategoryId === category.id) {
              matches++;
            }
          });

          if (matches > 0 || this.selectedCategoryId === -1) {
            return true;
          }
        });
      }

      return [];
    },

    categories () {
      const categories = {};

      if (this.$store.getters.getPostcards) {
        this.$store.getters.getPostcards.forEach((item) => {
          item.categories.forEach(category => {
            if (!categories[category.id]) {
              categories[category.id] = {
                id: category.id,
                name: category.name
              };
            }
          });
        });
      }

      return categories;
    }
  },
  created () {
    if (this.selectionData.card.id) {
      this.selectedCard = this.$store.getters.getSelectedPostcard;
    }
  }
};
</script>

<style lang="scss" scoped>
/**
 * ModalPostcardMotives
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Postcard selection
 * @since 2021-10-26
**/

$component: 'modal-postcard-motives';

.#{$component} {
  &__categories {
    @include unlist;
    display: none;
    flex-wrap: wrap;
    @include margin-bottom(map-get($spacers, 3));
  }

  &__category {
    @include margin-bottom(map-get($spacers, 2));
    @include margin-right(map-get($spacers, 2));
  }

  &__list {
    @include unlist;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
  }

  &__item {
    flex-basis: 47%;
    margin-bottom: 6%;

    &.--has-full-width {
      flex-basis: 100%;
    }
  }

  &__card {
    text-align: center;
    cursor: pointer;

    &:not(.--is-selected) {
      @include hover() {
        .#{$component} {
          &__picture {
            box-shadow: 0px 0px 10px rgba($primary, 0.3);
          }

          &__check {
            display: block;

            &:before {
              opacity: 0.5;
            }
          }
        }
      }
    }

    &.--is-selected {
      .#{$component} {
        &__picture {
          border-color: $primary;
          box-shadow: 0px 0px 10px rgba($primary, 0.3);
        }

        &__check {
          display: block;
        }

        &__name {
          color: $ink;
          font-weight: $font-weight-bold;
        }
      }
    }
  }

  &__picture {
    position: relative;
    aspect-ratio: 1 / 1;
    @include margin-bottom(map-get($spacers, 3));
    border: 2px solid transparent;
    border-radius: $border-radius-sm;
    box-shadow: 0px 0px 13px rgba(0, 0, 0, 0.15);

    img {
      display: block;
      width: 100%;
    }
  }

  &__check {
    display: none;
    width: $font-size-base * 1.6;
    height: $font-size-base * 1.6;
    position: absolute;
    left: 50%;
    @include rfs(- $font-size-base * 0.7, bottom);
    transform: translateX(-50%);
    border: 1px solid $white;
    border-radius: 50%;
    background-color: $white;
    font-size: $font-size-base * 1.5;
    color: $primary;
  }

  &__name {
    color: $ink-light;
  }

  hr {
    border-color: $ink-lightest;
    background-color: $ink-lightest;
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
  }
}
</style>
